import React from 'react';
import { hours, monthDays } from '../constants/constants';
import ControlledInput from '../../../components/ControlledInput';
import ControlledDropdown from '../../../components/ControlledDropdown';
import { ERROR_TEXT } from '../../../constants';
import dayjs from 'dayjs';
import { useFormContext } from 'react-hook-form';

const aliasMap = (label, names) => Object.fromEntries(names.map((name) => [name, label]));

const LABELS = {
  ...aliasMap('День отправки', ['send_at_day', 'sent_at_day', 'day']),
  ...aliasMap('Время отправки показаний', ['hour', 'send_at_hour', 'sent_at_hour']),
  ...aliasMap('Код плательщика', ['pay_code', 'payment_code']),
  ...aliasMap('Логин', ['lg', 'login']),
  ...aliasMap('Пароль', ['ps', 'password']),
  dog_tag: 'Номер договора',
  send_to: 'Email для оповещения',
  url: 'Сайт компании',
  date: 'Дата отправки',
  comment: 'Комментарий',
  additional_info: 'Дополнительная информация',
  contract_number: 'Номер договора',
  apart_owner: 'Собственник квартиры',
  apartment: 'Номер квартиры',
  account_number: 'Лицевой счёт',
  meter_guid: 'Идентификатор счетчика в ГИС ЖКХ',
};

const isHourField = (name) => name === 'hour' || name.endsWith('_hour');

const getFieldOptions = (name) => (isHourField(name) ? hours : monthDays);

const hideField = ['device_id', 'is_active', 'enabled', 'template_id', 'email', 'organization_id', 'created_at', 'meter_guid'];
const isNotRequiredTypes = ['integrations.manual', 'email_template'];

const DynamicIntegrationForm = ({ configuration, mode, integrationType }) => {
  const { formState } = useFormContext();
  const renderField = (field, parentName = '') => {
    const { name, type } = field;
    const fieldName = parentName ? `${parentName}.${name}` : name;
    const label = LABELS[name] ?? name;

    const isRequired = !isNotRequiredTypes.includes(integrationType);
    const commonRules = isRequired ? { required: { value: true, message: ERROR_TEXT.REQUIRED } } : {};

    if (hideField.includes(name)) return <ControlledInput key={fieldName} classContainer={'hidden'} name={fieldName} />;

    switch (type) {
      case 'string':
        return <ControlledInput rules={commonRules} key={fieldName} classContainer={'mb-4'} name={fieldName} label={label} type="text" placeholder={label} />;

      case 'int':
        return (
          <ControlledDropdown
            rules={commonRules}
            key={fieldName}
            className="w-full my-4"
            label={label}
            type={'number'}
            name={fieldName}
            defaultValue={mode !== 'edit' ? getFieldOptions(name)[0].val : ''}
            options={getFieldOptions(name)}
            id={fieldName}
            valkey="val"
            optkey="opt"
          />
        );

      case 'record':
        return field?.fields?.map((subField) => renderField(subField, fieldName));

      case 'date':
        const defaultDate = formState?.defaultValues?.date;
        const defaultValue = defaultDate ? dayjs(defaultDate).date() : '';

        const defaultDay = mode !== 'edit' ? getFieldOptions(name)[0].val : defaultValue;

        return (
          <ControlledDropdown
            rules={commonRules}
            key={fieldName}
            className="w-full my-4"
            label={label}
            type={'number'}
            name={fieldName}
            defaultValue={defaultDay}
            options={getFieldOptions(name)}
            id={fieldName}
            valkey="val"
            optkey="opt"
          />
        );

      default:
        return null;
    }
  };

  return <>{configuration.map((field) => renderField(field))}</>;
};

export default DynamicIntegrationForm;
